<template>
  <section class="p-4">
    <v-tabs fixed-tabs centered v-model="tab" active-class="bg-primary">
      <v-tab
        key="projects"
        active-class="bg-app-primary text-white rounded"
        class="tab-list"
        @click="clearQueryParams"
        >Proyectos</v-tab
      >
      <v-tab
        id="tab-presale"
        class="tab-list"
        active-class="bg-app-primary text-white rounded"
        key="presale"
        >Preventas</v-tab
      >
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item key="projects">
        <index-projects
          ref="listProjects"
          @create-presale="createPresale"
        ></index-projects>
      </v-tab-item>
      <v-tab-item key="presale">
        <index-presale ref="listPresale"></index-presale>
      </v-tab-item>
    </v-tabs-items>
  </section>
</template>

<script>
import indexProjects from "./indexProjects.vue";
import indexPresale from "../presale/index.vue";
import { mapActions, mapGetters } from "vuex";
import { authUsuarioComputed } from "@/state/helpers";
import roles from "@/mixins/roles";
import { COST_CENTER_MANAGMENT_CONTROL, NEW_COST_CENTER_MANAGMENT_CONTROL } from "@/constants/common";
import config from "@/config";
import { setLocalStorageCostCenterUserAuth } from "@/helpers/employee";
export default {
  mixins: [roles],
  components: { indexProjects, indexPresale },
  data() {
    return {
      tab: "presale",
    };
  },
  async mounted() {
    await this.getEmployeeData();
    if (
      this.currentUserIsSuperAdmin ||
      this.verifyUserBelongsToCgestionCostCenter
    ) {
      this.getBusinessUnits();
    } else {
      this.getBusinessUnits({
        user_email: this.user.email,
      });
    }
    if (this.$route.query.presale_tab) {
      this.tab = "presale";
      document.getElementById("tab-presale").click();
    }
  },
  methods: {
    ...mapActions({
      getBusinessUnits: "common/getBusinessUnits",
      getEmployees: "maintainers/getEmployees",
    }),
    clearQueryParams() {
      if (this.$route.query.presale_tab) {
        this.$router.replace({
          query: {},
        });
      }
    },
    async getEmployeeData() {
      let self = this;
      await self.getEmployees({
        password: config.password_manteiners,
        page: 0,
        filter: this.user.email,
        only_user_auth: true,
      });
      await this.verifyBusinessUnitAndGetStages();
    },
    verifyBusinessUnitAndGetStages() {
      if (
        !this.currentUserIsSuperAdmin &&
        !this.verifyUserBelongsToCgestionCostCenter
      ) {
        if (this.dataEmployees.employees.length) {
          setLocalStorageCostCenterUserAuth(
            this.dataEmployees.employees[0].cost_center.code
          );
          if (this.$refs && this.$refs["listProjects"]) {
            this.$refs["listProjects"].getStagesProjectsData(
              this.dataEmployees.employees[0].cost_center.code.slice(0, 2)
            );
          }
        }
      }
    },
    createPresale() {
      document.getElementById("tab-presale").click();
      setTimeout(() => {
        this.$refs.listPresale.openModalUpdateOrCreatePresale();
      }, 200);
    },
  },
  computed: {
    ...authUsuarioComputed,
    ...mapGetters({
      dataEmployees: "maintainers/employeeInfoUser",
    }),
    verifyUserBelongsToCgestionCostCenter() {
      return (
        this.dataEmployees.employees.length &&
        this.dataEmployees.employees.find(
          (employee) =>
            employee.cost_center.code == COST_CENTER_MANAGMENT_CONTROL ||  employee.cost_center.code == NEW_COST_CENTER_MANAGMENT_CONTROL
        )
      );
    },
  },
};
</script>

<style></style>
